import { Tooltip } from 'react-tooltip';
import { COLORS } from '../../../constants';

export const FieldsTooltip = ({
    id = 'my-tooltip',
    place = 'right',
    width = '15rem',
    backgroundColor = COLORS.YELLOW,
    color = COLORS.BLACK,
    openOnClick = false,
    clickable = false,
    globalCloseEvents,
    positionStrategy = 'absolute',
}) => {
    return (
        <Tooltip
            id={id}
            place={place}
            opacity={1}
            openOnClick={openOnClick}
            clickable={clickable}
            globalCloseEvents={globalCloseEvents}
            positionStrategy={positionStrategy}
            style={{
                width,
                backgroundColor,
                textAlign: 'center',
                fontWeight: 'bold',
                color,
                zIndex: 1000,
            }}
        />
    );
};
